import { ERP_GET_Quotation } from '../../../helpers/fakebackend_helper';
import { GET_QUOTATION_DETAILS } from "../../../helpers/url_helper";
import { Raise_Post_Quotation , Raise_Patch_Quotation} from '../../../helpers/fakebackend_helper'
import { createAsyncThunk } from '@reduxjs/toolkit';

export const GET_Quotation = createAsyncThunk(
    'Quotation/get',
    async (QuotationID, thunkAPI) => {
        try {
            console.log('Fetching ticket details for SupportID:', SupportID);

            if (!SupportID) {
                return thunkAPI.rejectWithValue('Support ID could not be extracted from the URL.');
            }

            // Call the API helper
            const api = GET_QUOTATION_DETAILS
            const param = QuotationID;
            const masterURL = `${api}${param}`;
            const response = await ERP_GET_Quotation(masterURL);
            return response;

        } catch (error) {
            // Handle errors gracefully
            return thunkAPI.rejectWithValue(error.response?.data || error.message || 'Something went wrong');
        }
    }
);

export const POST_Quotation = createAsyncThunk(
  "Quotation/post",
  async (body, thunkAPI) => {
    try {
      if (!body) return;
        const response = Raise_Post_Quotation(body);
      const data = await response;
      return;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const PATCH_Quotation = createAsyncThunk(
  "Quotation/patch",
  async (body, thunkAPI) => {
    try {
      if (!body) return;

        const response = await Raise_Patch_Quotation(body);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);